"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUserOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.57 19.18A21.54 21.54 0 0016 16a21.54 21.54 0 00-11.57 3.18l-.43.3V28h24v-8.52zM26 26H6v-5.44A20.24 20.24 0 0116 18a20.38 20.38 0 0110 2.56zM16 14c5 0 5-4.53 5-6 0-5-2.72-6-5-6-1.87 0-5 .78-5 6s3.13 6 5 6zm0-10c1.48 0 3 .48 3 4 0 3.35-1.1 4-3 4-1.29 0-3-.42-3-4s1.52-4 3-4z" })));
}
exports.default = SvgUserOutline;
//# sourceMappingURL=UserOutline.js.map